import * as React from "react";
import type { SVGProps } from "react";
const SvgLeaf = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M13.374 10.014a1 1 0 0 1-.388 1.36C8.86 13.666 7 17.794 7 22a1 1 0 1 1-2 0c0-4.793 2.14-9.666 7.014-12.374a1 1 0 0 1 1.36.388Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.347 16.653c1.969 1.969 6.135 1.952 9.371-1.284 1.895-1.894 2.853-4.618 3.166-7.129.145-1.161.189-2.37-.015-3.528-5.606-.224-8.534-.134-11.238 2.57-3.236 3.236-3.253 7.402-1.284 9.371ZM20.233 2.767C14 2.5 9.848 2.236 6.217 5.867c-3.724 3.724-4.299 9.186-1.284 12.2 3.014 3.015 8.476 2.44 12.2-1.284 4.631-4.631 4.298-12.818 3.1-14.016Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgLeaf;
